export default __webpack_public_path__ + "static/media/img_408.b30aec3e.svg";